export const NOTIFICATION_DURATION_IN_MS = 6000;
